import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn } from "./common.styles";
import { TinyText } from "./HXMobilePage.styles";
export const HelperText = styled(TinyText) `
    color: ${colors.black_light};
    padding-left: 14px;
    text-align: left;
    align-self: stretch;
`;
export const FormFieldContainer = styled(FlexColumn) `
    gap: 8px;
`;
